import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=480a8aea&scoped=true&"
import script from "./forgetPwd.vue?vue&type=script&lang=js&"
export * from "./forgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=480a8aea&scoped=true&lang=css&"
import style1 from "./forgetPwd.vue?vue&type=style&index=1&id=480a8aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480a8aea",
  null
  
)

export default component.exports